export default function ErrorIcon({ className = '' }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2Zm0 11.25a.75.75 0 0 1-.75-.75V8a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75Zm0 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
